var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"vpd-md-viewer"},[(_vm.title)?_c('vpd-card-title',{attrs:{"title":_vm.title,"has-back-button":""}}):_vm._e(),_c('br'),_c('vpd-markdown',{attrs:{"source":_vm.source}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }